import { stringToEnum } from '@snap-types/util/enum';

export enum PriceSegmentType {
  CustomerPotential = 'CustomerPotential',
  CustomerPortals = 'CustomerPortals',
  CustomerTerms = 'CustomerTerms',
  ProductOperationsCount = 'ProductOperationsCount',
  ProductComplexity = 'ProductComplexity',
  MarketIndustry = 'MarketIndustry',
  LastTransactionAge = 'LastTransactionAge',
  LastGrossMargin = 'LastGrossMargin',
}

export const priceSegmentTypeSchema = stringToEnum(PriceSegmentType);
